export default "__VITE_ASSET__BTIVHvfV__"